import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useUpdateUserMutation, useUploadUserPFPMutation } from "../../state/api";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import { useDispatch } from 'react-redux';
import { setUserPFP } from '../../state/index';
import { EditOutlined } from '@mui/icons-material';

const Settings = () => {
  // Initial state for the profile.
  const [profile, setProfile] = useState({
    name: '',
    phoneNumber: '',
    city: '',
    country: '',
  });
  const user = useSelector((state) => state.global.user);
  const displayName = user?.displayName ? user.displayName : "Loading...";
  const displayEmail = user?.email ? user.email : "Loading...";
  const [updateUser] = useUpdateUserMutation();
  const [profilePic, setProfilePic] = useState('');
  const [uploadUserProfilePic, { isLoading: isUploadingPic }] = useUploadUserPFPMutation({ email: user.email, file: profilePic });
  const [imagePreview, setImagePreview] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProfilePic(file);
    const previewURL = URL.createObjectURL(file);
    setImagePreview(previewURL);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      const updatedProfile = {
        name: user.name,
        phoneNumber: user.phoneNumber,
        city: user.city,
        country: user.country,
      };
      setProfile(updatedProfile);
    }
  }, [user]);

  // Handle form inputs.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  // Submit the form to update the profile.
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await updateUser({
        email: user.email,
        name: profile.name,
        phoneNumber: profile.phoneNumber,
        city: profile.city,
        country: profile.country,
      });

      console.log('Profile updated successfully!', response);
    } catch (error) {
      console.error('Failed to update profile: ', error);
    }
  };

  const handleProfilePicture = async (e) => {
    e.preventDefault();
    try {
      const response = await uploadUserProfilePic({ email: user.email, file: profilePic });
      console.log('Profile picture updated successfully!', response);
      setImagePreview(null);
      const newProfilePicPath = response.data.user.profilePic;
      dispatch(setUserPFP(newProfilePicPath));

      const updatedUser = { ...user, profilePic: newProfilePicPath };
      localStorage.setItem('user', JSON.stringify(updatedUser));
    } catch (error) {
      console.error('Failed to change profile picture', error);
    }
  }
  
  const userProfileImage = user?.photoURL 
    ? `${user.photoURL}` : `${user.profilePic}`;

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="SETTINGS" subtitle="Edit profile" />
        <Box>
        </Box>
      </FlexBetween>
      <Box
        sx={{
          marginTop: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Grid item xs={12}>
          <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          justifyContent="center" 
          height="100%"
          mt={5} 
          >
          <Box
            component="img"
            alt="profile"
            src={userProfileImage}
            height="120px"
            width="120px"
            borderRadius="50%"
            marginBottom={2}
            sx={{ objectFit: "cover" }}
          />
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="raised-button-file"
              multiple
              type="file"
              onChange={handleFileChange}
            />
            <label>
              <Button component="span"
                sx={{ color: '#ffffff', fontSize:"20" }}
              >
                {displayEmail}
              </Button>
            </label>
            <label htmlFor="raised-button-file">
              <Button variant="raised"
                component="span"
                sx={{ color: '#ffffff', fontSize:"20" }}
              >
                <EditOutlined sx={{ marginRight:"3" }}/>
                Change Picture
              </Button>
            </label>
          </Box>
        </Grid>
          {imagePreview && (
              <Box
                  component="img"
                  alt="preview"
                  src={imagePreview}
                  height="120px"
                  width="120px"
                  borderRadius="50%"
                  marginBottom={2}
                  sx={{ objectFit: "cover" }}
              />
          )}
          {profilePic && (
            <Button
            onClick={ handleProfilePicture }
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
              disabled={isUploadingPic}
            >
              {isUploadingPic ? 'Uploading...' : 'Update Profile Picture'}
            </Button>
          )}
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }} width={400}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="name"
                name="name"
                required
                fullWidth
                id="name"
                label="Name"
                autoFocus
                value={displayName}
                onChange={handleChange}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="phoneNumber"
                label="Phone Number"
                id="phoneNumber"
                autoComplete="phone"
                value={profile.phoneNumber}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="city"
                label="City"
                id="city"
                autoComplete="address-level2"
                value={profile.city}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="country"
                label="Country"
                id="country"
                autoComplete="country"
                value={profile.country}
                onChange={handleChange}
              />
            </Grid>
            
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            color='secondary'
          >
            Update Profile
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
